// Generated types for Organisation
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { OrgType } from '../../shared/enums';

import { GroupWriteAPI } from './group';
import { IndustryReadAPI } from './industry';
import { SecurityScopeReadAPI, SecurityScopeWriteAPI } from '../../shared/types/securityscope';
import { GroupWriteAPISchema } from './group';
import { IndustryReadAPISchema } from './industry';
import { SecurityScopeReadAPISchemaObject, SecurityScopeWriteAPISchemaObject } from '../../shared/types/securityscope';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface OrganisationReadAPI extends SecurityScopeReadAPI {
  /** The name of the organization */
  name?: string;
  /** The type of organisation, indicating its role in the industry */
  type?: OrgType;
  /** A list of industries the organisation is associated with */
  industries?: IndustryReadAPI[];
}

export interface OrganisationWriteAPI extends SecurityScopeWriteAPI {
  groups?: (string | GroupWriteAPI)[];
  /** The name of the organization */
  name?: string;
  /** The type of organisation, indicating its role in the industry */
  type?: OrgType;
  /** A list of industries the organisation is associated with */
  industries?: IndustryReadAPI[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const OrganisationReadAPISchema: z.ZodType<OrganisationReadAPI> = SecurityScopeReadAPISchemaObject.extend({
  name: z.string().optional(),
  type: z.nativeEnum(OrgType).optional(),
  industries: z.array(z.lazy(() => IndustryReadAPISchema)).optional(),
}).passthrough();

export const OrganisationWriteAPISchema: z.ZodType<OrganisationWriteAPI> = SecurityScopeWriteAPISchemaObject.extend({
  groups: z.array(z.union([z.string(), z.lazy(() => GroupWriteAPISchema)])).optional(),
  name: z.string().optional(),
  type: z.nativeEnum(OrgType).optional(),
  industries: z.array(z.lazy(() => IndustryReadAPISchema)).optional(),
}).passthrough();
